import { DatePicker } from "antd";
import momentGenerateConfig from "rc-picker/es/generate/moment";

const MomentDatePicker = DatePicker.generatePicker(momentGenerateConfig);

export default MomentDatePicker;
export const TimePicker = MomentDatePicker.TimePicker;
